import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-leaf-line', title: 'Idaho Climate Expertise', desc: "We know North Idaho's soil, freeze cycles, and growing season — your landscape is built to thrive here year after year." },
  { icon: 'ri-ruler-2-line', title: 'Full Design-to-Build', desc: 'One team. Concept through completion. No subcontractors, no handoffs, no surprises on your project.' },
  { icon: 'ri-time-line', title: 'On-Time, Every Time', desc: 'Clear schedules, consistent communication. You always know exactly where your project stands.' },
  { icon: 'ri-shield-check-line', title: 'Licensed & Fully Insured', desc: 'All required credentials for residential and commercial work in Idaho. Full documentation available on request.' },
  { icon: 'ri-home-smile-line', title: 'Family-Owned & Local', desc: "We're not a franchise. We're your neighbors — accountable, accessible, and invested in this community." },
  { icon: 'ri-recycle-line', title: 'Built for Decades', desc: 'Premium materials, proper installation technique. Your outdoor space should still look incredible 20 years from now.' },
];

export default function WhyChooseUs() {
  return (
    <section className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[640px]">

        {/* Left — deep forest, stats */}
        <div className="lg:col-span-4 bg-[#07140a] px-10 lg:px-14 py-20 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="h-px w-8 bg-gold"></div>
              <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-gold">Why CQC</span>
            </div>
            <h2 className="font-serif text-white font-semibold leading-[1.05] mb-14" style={{ fontSize: 'clamp(2rem, 3vw, 2.8rem)' }}>
              Why Homeowners Choose<br />
              <em className="italic text-gold">CQC Landscaping</em>
            </h2>
          </div>

          {/* Stats */}
          <div className="space-y-0 divide-y divide-white/8">
            {[
              { value: '500+', label: 'Projects Completed' },
              { value: '10+', label: 'Years in North Idaho' },
              { value: '5.0★', label: 'Google Rating' },
            ].map((s, i) => (
              <div key={i} className="py-7">
                <div className="font-serif text-5xl text-gold font-semibold leading-none">{s.value}</div>
                <div className="font-sans text-white/40 text-xs tracking-wide mt-2">{s.label}</div>
              </div>
            ))}
          </div>

          <Link to="/#estimate" className="whitespace-nowrap mt-10 inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-forest-deep font-bold text-sm rounded-full px-7 py-3.5 transition-all cursor-pointer shadow-xl shadow-gold/25">
            Get Free Estimate <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Right — cream, features grid */}
        <div className="lg:col-span-8 bg-[#f5f0e8] px-10 lg:px-16 py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 h-full content-center">
            {features.map((f, i) => (
              <div
                key={i}
                className="flex gap-4 bg-white rounded-2xl p-6 border border-stone/40 hover:border-gold/30 hover:shadow-lg transition-all group"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#07140a]/6 group-hover:bg-[#07140a] transition-colors shrink-0">
                  <i className={`${f.icon} text-forest group-hover:text-white text-base transition-colors`}></i>
                </div>
                <div>
                  <h3 className="font-sans font-bold text-forest text-sm mb-1.5">{f.title}</h3>
                  <p className="font-sans text-charcoal-muted text-xs leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
